module.exports = __webpack_public_path__ + "img/TermCondition.430ea4ef.svg";